import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { Link, Box } from '@material-ui/core'
import { DIGITAL_UI } from '../theme'
import config from '../config'

const useStyles = makeStyles(theme => ({
    root: {
        fontFamily: 'Barlow',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: DIGITAL_UI.footer || '#001E50',
        color: '#ffffff',
        width: '100%',
        paddingBottom: "55px",
        fontSize: '12px',
        gap: '24px'
    },
    copyright: {
        display: 'flex',
        flexDirection: 'row',
        fontSize: '12px',
    },
    footerLink: {
        fontSize: "12px",
        lineHeight: "17px",
        fontWeight:400,
        textDecoration: "none",
        color: "#FFFFFF",
        "@media only screen and (max-width: 650px)":{
            marginTop: "8px",
            fontSize:"14px"
        }
    },
    divider: {
        marginTop: "55px",
        width: "100%"
    },
    policies: {
        display: "flex",
        flexDirection: "row",
        whiteSpace: "nowrap",
        flexWrap: "wrap",
        fontWeight: 400,
        "@media only screen and (max-width: 650px)":{
            flexDirection: "column"
        }
    },
    pipe: {
        "@media only screen and (max-width: 650px)":{
            display: "none"
        }
    },
    gutter: {
        marginLeft:"8em", 
        marginRight:"8em",
        "@media only screen and (max-width: 650px)":{
            marginLeft:"4em", 
            marginRight:"4em",
        }
    }
}));

const Footer = () => {
    const classes = useStyles()
    const { userAgreement, privacyPolicy, privacyPractices, nonDiscrimination, contactUs } = config
    const footerLinks = [
        {
            title: 'User Agreement',
            url: userAgreement,
        },
        {
            title: 'Terms of User & Privacy Policy',
            url: privacyPolicy,
        },
        {
            title: 'Notice of Privacy Practices',
            url: privacyPractices,
        },
        {
            title: 'Non-Discrimination and Communication Assistance',
            url: nonDiscrimination,
        },
        {
            title: 'Contact Us',
            url: contactUs,
        }
    ]

    return (
        <Paper className={classes.root} square role="contentinfo" id="footer" elevation={1} component='footer' >
            <div className={classes.gutter}>
                <hr className={classes.divider} />
            </div>
            <div className={classes.gutter}>
                Copyright &copy; {new Date().getFullYear()} Providence Health Plan, Providence Plan Partners, and Providence Health Assurance. All Rights Reserved.
            </div>

            <div className={`${classes.gutter} ${classes.policies}`}>
                {footerLinks.map((footer, index) => 
                    <Box component="span" key={footer.title}>
                        <Link
                            href={footer.url}
                            target='_blank' 
                            rel='noreferrer'
                            className={classes.footerLink}
                            sx={{
                                color: "white",
                                "&:hover": {
                                    opacity: 0.8,
                                },
                            }}
                        >
                            { footer.title }
                        </Link>
                        {index < footerLinks.length -1 && (
                            <Box className={classes.pipe} component="span" sx={{ mx: 0.5 }}>
                                |
                            </Box>
                        )}
                    </Box>
                )}
            </div>
            
        </Paper>
    )
}

export default Footer
